import { AxiosResponse } from 'axios'
import styles from './sign-in-form-layout.module.scss'
import { authApi, VerifyOtpResponse } from '@/api/auth'
import { EmailForm } from "../email-form"

 interface Props {
    className?: string
    requestOTP: (email: string) => Promise<AxiosResponse<{ countdown: number }>>
    onLogin: (data: VerifyOtpResponse) => void
}

export const SignInForm: React.FC<Props> = ({ onLogin, requestOTP }) =>
    (
        <div className={styles.signInFormWrapper}>
            <EmailForm
                requestOTP={requestOTP}
                verifyOTP={(email: string, code: string) => authApi.verifyOTP(email, code)}
                onLogin={onLogin} />
        </div>
    )
